var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"curator",staticClass:"aha-row clickable"},[_c('a',{attrs:{"href":_vm.post.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.post.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }